import { Component } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';

@Component({
  selector: 'app-provinces-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './provinces-tab.component.html',
  styleUrl: './provinces-tab.component.scss',
  providers: [{ provide: TabComponent, useExisting: ProvincesTabComponent }],
})
export class ProvincesTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Provinces');

  public async main(): Promise<void> {}
}
